import Grid from '@material-ui/core/Grid';
import GrainIcon from '@material-ui/icons/Grain';
import ReorderIcon from '@material-ui/icons/Reorder';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { APPLICATION_PATHS, ENTITLEMENTS } from '../../application-core/constants';
import ComponentTitle from '../../core/ComponentTitle';
import InAppBar from '../../core/InAppBar';
import { checkResourceEntitlements, processHashLocation } from '../../core/utils/utils';
import withGS from '../../core/withGShoc';
import GS from '../../grafsync/grafsync';
import CollectionView from './CollectionView';

class CollectionEditorContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      activeConcept: null,
      foundRef: null,
      foundTime: undefined,
      viewLang: props.defaultLang
    };
  }

  static getDerivedStateFromProps(props, state) {
    const paramsMap = processHashLocation(props.location);
    const concept = paramsMap.get("concept");
    if (concept !== state.activeConcept) {
      return {
        ...(state.activeConcept !== concept) &&
        { activeConcept: (concept === undefined || concept === null || concept === "") ? null : concept },
      };
    }
    return null;
  }

  includeExistingConcept = (existingIRI) => {
    GS.loadData([existingIRI], {}, this.props.graph).then(() => {
      // We check that somebody else hasn't added it while we've been looking!
      const memberProp = this.props.data.type.includes("OrderedCollection") ? "memberList" : "member";
      if (!this.props.data[memberProp] || (this.props.data[memberProp] && !this.props.data[memberProp].includes(existingIRI))) {
        if (memberProp === "memberList") {
          GS.insert(this.props.id, this.props.graph, memberProp, existingIRI);
        }
        else {
          this.props.onAdd(memberProp, existingIRI);
          this.showDetail(existingIRI);
          this.setState({
            foundTime: Date.now(),
            foundRef: React.createRef()
          });
        }
      }
    });
  };

  findConcept = (existingIRI) => {
    this.showDetail(existingIRI);
    this.setState({
      foundTime: Date.now(),
      foundRef: React.createRef()
    });
  };

  deleteConcept = (iri) => {
    GS.deleteResource(iri, this.props.graph);
    this.showDetail(null);
  };

  breakLink = (position, iri) => {
    const memberProp = this.props.data.type.includes("OrderedCollection") ? "memberList" : "member";
    if (memberProp === "memberList") {
      GS.remove(this.props.id, this.props.graph, memberProp, position);
    }
    else {
      this.props.onDelete(memberProp, iri);
    }
    this.showDetail(null);
  };

  setViewLanguage = (lang) => this.setState({ viewLang: lang });

  showDetail = (iri) => {
    const link = APPLICATION_PATHS.TAXONOMY_MANAGER + '/project/collection#project=' + this.props.project
      + "&collection=" + this.props.id
      + (iri ? "&concept=" + iri : "");
    this.setState({ activeConcept: iri }, () => this.props.history.push(link));
  };

  toggleCollectionDetail = () => this.props.toggleCollectionDetail(0);

  buildTaxonomyLink(view, concept, label, schemeIRI) {
    let link = APPLICATION_PATHS.TAXONOMY_MANAGER + '/project/taxonomy#project='
      + this.props.project + "&taxonomy=" + schemeIRI + "&view=" + view;
    link += concept !== null ? "&concept=" + concept : "";
    link += label !== null ? "&label=" + label : "";
    return link;
  }

  showFloatingLabel = (iri) => {
    const link = APPLICATION_PATHS.TAXONOMY_MANAGER + '/project/floating#project=' + this.props.project + "&view=label&label=" + iri;
    this.props.history.push(link);
  };

  showLabelDetail = (iri, schemeIRI) => {
    const link = this.buildTaxonomyLink("label", this.state.activeConcept, iri, schemeIRI);
    this.props.history.push(link);
  };

  render() {

    const { activeConcept, viewLang, foundRef, foundTime } = this.state;
    const { data, defaultLang, skosXL, project, graph, entitlements, projectUsers } = this.props;

    const isReadOnly = checkResourceEntitlements(data, ENTITLEMENTS.EDIT_TAXONOMY);
    const appBar = <InAppBar
      tabValue={0}
      tabItems={[{
        icon: data.type.includes("OrderedCollection") ? ReorderIcon : GrainIcon,
        label: "Collection"
      }]} />;

    return (
      <React.Fragment>
        <ComponentTitle title={data.title} id={data.id} viewLang={viewLang} defaultLang={defaultLang} onClick={this.toggleCollectionDetail} />
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <CollectionView
              appBar={appBar}
              entitlements={entitlements}
              foundRef={foundRef}
              onIncludeExistingConcept={this.includeExistingConcept}
              data={data}
              graph={graph}
              hiddenProps={data.hiddenProp}
              skosXL={skosXL}
              project={project}
              foundTime={foundTime}
              projectUsers={projectUsers}
              defaultLang={defaultLang}
              activeConcept={activeConcept}
              viewLang={viewLang}
              showFloatingLabel={this.showFloatingLabel}
              showLabelDetail={this.showLabelDetail}
              onSelect={this.showDetail}
              onFindConcept={this.findConcept}
              onSelectViewLanguage={this.setViewLanguage}
              onBreakLink={this.breakLink}
              isReadOnly={isReadOnly}
              onDeleteConcept={this.deleteConcept}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }

}

CollectionEditorContainer.propTypes = {
  onAdd: PropTypes.func,
  onDelete: PropTypes.func,
  toggleCollectionDetail: PropTypes.func,
  id: PropTypes.string.isRequired,
  entitlements: PropTypes.array.isRequired,
  graph: PropTypes.string.isRequired,
  project: PropTypes.string.isRequired,
  skosXL: PropTypes.bool.isRequired,
  projectUsers: PropTypes.array,
  data: PropTypes.object.isRequired,
  history: PropTypes.object,
  location: PropTypes.object,
  defaultLang: PropTypes.string.isRequired
};

export default withRouter(withGS(CollectionEditorContainer));